import {observer} from "mobx-react";
import EditorPageLayout from "../../../../../../components/layouts/editor-page/editor-page-layout";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import {useCallback, useState} from "react";
import {ConfirmModal} from "../../../../../../components/modal/components/confirm-modal/confirm-modal";
import useNavigationBlocker from "../../../../../../hooks/navigation-blocker-hook";
import ListLayout from "../../../../../../components/layouts/list-layout/list-layout";
import ExchangeOrderInvoice from "../../../../../../images/previews/exchange-order-invoice.svg";
import TranslationInput from "../../../../../../translation/translation-input/translation-input";
import {EXCHANGE_ORDER_INVOICE_EMAIL} from "./constants";
import ControlGroupWithPreview
    from "../../../../../../components/layouts/control-group-with-preview/control-group-with-preview";
import {FormField} from "../../../../../../components/form-field/form-field";

const ExchangeOrderInvoiceEditor: React.FC = observer(() => {

    const [isShowUnsaved, setIsShowUnsaved] = useState(false);

    const {
        hasChanges: hasTranslationChanges,
        discardChanges: translationsDiscardChanges,
        save: saveTranslations,
        getHint
    } = useTranslation();

    const hasChanges = () => {
        return hasTranslationChanges();
    }

    const {retryNavigation, unblockNavigation} = useNavigationBlocker(
        () => hasChanges(),
        useCallback(() => setIsShowUnsaved(true), [setIsShowUnsaved])
    );

    const discardChanges = () => {
        translationsDiscardChanges();
    }

    const onSaveClicked = () => {
        const promised = [];

        if (hasTranslationChanges()) {
            promised.push(
                saveTranslations()
            );
        }

        Promise.all(promised).then(() => {
            unblockNavigation();
        })
    }

    return <>
        <EditorPageLayout
            toolbar={{
                saveButton: {
                    hasChanges: hasChanges(),
                    disabled: !hasChanges(),
                    onClick: onSaveClicked
                }
            }}
        >
            <ListLayout>
                <ControlGroupWithPreview
                    preview={
                        <ListLayout>
                            <img src={ExchangeOrderInvoice} alt="" />
                        </ListLayout>
                    }
                    gridStyle={
                        {
                            childrenWidth: { width: 1.5 , type: 'fr' },
                            previewWidth: { width: 2, type: 'fr' }
                        }
                    }>
                    <ListLayout>
                        <FormField label={'Subject'} instructions={getHint(EXCHANGE_ORDER_INVOICE_EMAIL.SUBJECT)}>
                            <TranslationInput translationKey={EXCHANGE_ORDER_INVOICE_EMAIL.SUBJECT}/>
                        </FormField>

                        <FormField label={'Instructions'} instructions={getHint(EXCHANGE_ORDER_INVOICE_EMAIL.CUSTOM_MESSAGE)}>
                            <TranslationInput translationKey={EXCHANGE_ORDER_INVOICE_EMAIL.CUSTOM_MESSAGE}/>
                        </FormField>

                        <FormField label={'Exchange Discount'} instructions={getHint(EXCHANGE_ORDER_INVOICE_EMAIL.LINE_ITEMS_EXCHANGE_DISCOUNT)}>
                            <TranslationInput translationKey={EXCHANGE_ORDER_INVOICE_EMAIL.LINE_ITEMS_EXCHANGE_DISCOUNT}/>
                        </FormField>

                        <FormField label={'Exchange Item'} instructions={getHint(EXCHANGE_ORDER_INVOICE_EMAIL.LINE_ITEMS_EXCHANGE_ITEM)}>
                            <TranslationInput translationKey={EXCHANGE_ORDER_INVOICE_EMAIL.LINE_ITEMS_EXCHANGE_ITEM}/>
                        </FormField>

                        <FormField label={'Exchange Paid Amount'} instructions={getHint(EXCHANGE_ORDER_INVOICE_EMAIL.EXCHANGE_PAID_AMOUNT)}>
                            <TranslationInput translationKey={EXCHANGE_ORDER_INVOICE_EMAIL.EXCHANGE_PAID_AMOUNT}/>
                        </FormField>
                    </ListLayout>
                </ControlGroupWithPreview>
            </ListLayout>
        </EditorPageLayout>
        {isShowUnsaved &&
            <ConfirmModal
                cancelButton={{
                    title: 'Cancel',
                    onClick: () => setIsShowUnsaved(false)
                }}
                okButton={{
                    title: 'Discard',
                    onClick: () => {
                        discardChanges();
                        setIsShowUnsaved(false);
                        retryNavigation();
                    }
                }}
            />
        }
    </>
});

export default ExchangeOrderInvoiceEditor;